import { defineStore } from 'pinia'
import { ref } from 'vue'
import { setUserCityResource } from '@/services/general.service'

export const useUserCityStore = defineStore('userCityStore', () => {
  const selectedCity = ref<{ slug: string; id: string; title: string } | null>(
    null
  )

  function setCity(city: { slug: string; id: string; title: string }) {
    return setUserCityResource
      .execute(
        {},
        {
          city: city?.id || null,
        }
      )
      .then(() => {
        selectedCity.value = city
      })
  }

  function clearCity() {
    selectedCity.value = null
  }

  return {
    selectedCity,
    setCity,
    clearCity,
  }
})
